module finadai.app.activities {
  export var NAME = 'finadai.app.activities';
  function ConfigRoutes($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider) {
    $urlRouterProvider.when('/activities', '/activities/report');
    $stateProvider
      .state('app.activities', {
        template: '<div ui-view></div>',
        url: '/activities',
      })
      .state('app.activities.report', {
        templateUrl: 'app/activities/report/report.tpl.html',
        controller: 'ActivitiesReportController',
        controllerAs: 'vm',
        url: '/report',
        resolve: {
          agentes: (agentsService: services.AgentsService) => agentsService.get()
        }
      });
  }
  export function run() {
    var activities = angular.module(NAME, [
      finadai.app.activities.report.NAME
    ]);
    activities.config(ConfigRoutes);
  }
} finadai.app.activities.run();